import React, { Component } from "react";
import Container from '../Container'
import styles from './styles.css'

class DownArrows extends Component {
  render() {
    const additionalArrowAmount = this.props.amount ? parseInt(this.props.amount) : 5
    let additionalArrows = []

    for (let index = 1; index < additionalArrowAmount; index++) {
      additionalArrows.push(
        <span key={index}>
          &nbsp;
          <svg width="20px" height="20px" viewBox="0 0 100 100"><use xlinkHref="#triangle" href="#triangle"></use></svg>
        </span>
      )
    }

    return (
      <Container align='center'>
        <div className="down-arrows">
          <svg width="20px" height="20px" viewBox="0 0 100 100" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="triangle" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
              <polygon id="Triangle" fill="#5ED5B9" transform="translate(50.000000, 50.000000) scale(1, -1) translate(-50.000000, -50.000000) " points="50 0 100 100 0 100"></polygon>
            </g>
          </svg>

          {additionalArrows}
        </div>
      </Container>
    );
  }
}

export default DownArrows;



// WEBPACK FOOTER //
// ./src/components/DownArrows/index.js